module.exports = __webpack_public_path__ + "static/media/st_mary_logo.14ad445c.jpg";